import { Directive, ElementRef, Renderer2, HostListener, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[pHubCharCounter]'
})
export class CharCounterDirective implements OnInit {
  // Allow setting a maxChars value from the host template, defaulting to 50.
  @Input() maxChars: number = 54;
  private counterElement: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    // Create a span element to hold the character count display.
    this.counterElement = this.renderer.createElement('span');
    
    // Style the counter element as needed.
    this.renderer.setStyle(this.counterElement, 'display', 'block');
    this.renderer.setStyle(this.counterElement, 'fontSize', '12px');
    this.renderer.setStyle(this.counterElement, 'color', '#666');
    this.renderer.setStyle(this.counterElement, 'textAlign', 'right');
    this.renderer.setStyle(this.counterElement, 'marginTop', '5px');
    this.renderer.setStyle(this.counterElement, 'marginLeft', '8px');
    // Append the counter element after the input field.
    const parent = this.el.nativeElement.parentNode;
   
    this.renderer.appendChild(parent, this.counterElement);
    
    // Initialize the counter display.
    this.updateCounter();
  }

  // Listen for input events on the host element.
  @HostListener('input')
  onInput(): void {
    this.updateCounter();
  }

  // Update the displayed character count.
  updateCounter(): void {
    const currentLength = this.el.nativeElement.value.length;
    const displayText = `${currentLength} / ${this.maxChars}`;
    this.renderer.setProperty(this.counterElement, 'innerText', displayText);
  }
}
